// extracted by mini-css-extract-plugin
export default {"container":"accordion_container__SrzsJ","section__title":"accordion_section__title__g0ceT","accordion__title":"accordion_accordion__title__Ph64x"};